module.exports = __webpack_public_path__ + "images/FUSA_icons/025-smartwatch.957b368f18d6b45af3454ffc16390652.svg";